import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { PopoverBody, UncontrolledPopover } from 'reactstrap';
import qwotedBadge from '../assets/images/qwoted100.png';

async function fetchTopPrProfileIds(baseV2Url) {
  const resp = await fetch(`${baseV2Url}/admin/api/qwoted_top_hundreds/current.json`);
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  const body = await resp.json();
  return Array.isArray(body.data)
    ? body.data.filter((item) => !item.hidden).slice(0, 100).map((item) => item.v1_profile_id.toString())
    : [];
}

function Badge() {
  return (
    <>
      <img id="top-100-badge" alt="Top PR" width={100} src={qwotedBadge} className="qwoted-100" />
      <UncontrolledPopover placement="auto" target="top-100-badge" trigger="hover focus">
        <PopoverBody>
          A ranking member of our 'Qwoted 100' list – a collection of the best of the best in PR, based on feedback from
          Qwoted’s media users.
        </PopoverBody>
      </UncontrolledPopover>
    </>
  );
}

function Top100Badge({ v1ProfileId }) {
  const baseV2Url = window.V2_URL;
  const [isTop, setIsTop] = useState(false);

  useEffect(() => {
    if (baseV2Url == null || v1ProfileId == null) {
      return;
    }

    async function load() {
      try {
        const idList = await fetchTopPrProfileIds(baseV2Url);
        setIsTop(idList.includes(v1ProfileId.toString()));
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Top100Badge top 100 PRs loading error:', err);
      }
    }

    load();
  }, [baseV2Url, v1ProfileId]);
  return v1ProfileId && baseV2Url && isTop ? <Badge /> : null;
}

Top100Badge.propTypes = {
  v1ProfileId: PropTypes.number.isRequired,
};

export default Top100Badge;
